// @generated by TypeGen from LogbookNavigation/StatelessNavigation.swift - DO NOT EDIT

export enum INavigationRecordingStatus {
  recording = "recording",
  paused = "paused",
  stopped = "stopped",
}
